import React, { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { Field, Formik, useFormikContext } from "formik";
import { PeekInput } from "@piiqtechnologies/ui-components";
import { ToggleLink } from "../toggle-link";
import messages from "../messages.i18n";
import { CommunityAutocompleteInput } from "./CommunityAutocompleteInput";
import { useSearchSelectFormValidationSchema, SearchSelectFormInitialValues } from "./SearchSelectFormConfig";
const FormValuesWatcher = ({ onSelect }) => {
    const { values, isValid } = useFormikContext();
    const prevResultRef = useRef("");
    useEffect(() => {
        const community = values.communitySearch;
        let result = null;
        if (isValid && community && community.name) {
            result = {
                name: community.name,
                address: community.address,
                website: values.communityWebsite || community.website || "",
            };
        }
        const resultKey = result ? `${result.name}|${result.address}|${result.website}` : "";
        if (resultKey !== prevResultRef.current) {
            prevResultRef.current = resultKey;
            onSelect(result);
        }
    }, [values, isValid, onSelect]);
    return null;
};
export const SearchSelectForm = ({ onSelect, onManualEntry }) => {
    const intl = useIntl();
    const validationSchema = useSearchSelectFormValidationSchema();
    return (React.createElement(Formik, { initialValues: SearchSelectFormInitialValues, validationSchema: validationSchema, validateOnChange: true, validateOnBlur: true, onSubmit: () => { } }, ({ values }) => (React.createElement(React.Fragment, null,
        React.createElement(FormValuesWatcher, { onSelect: onSelect }),
        React.createElement(Field, { id: "communitySearch", name: "communitySearch", label: intl.formatMessage(messages.searchForCommunity), placeholder: intl.formatMessage(messages.placeholder), required: true, component: CommunityAutocompleteInput }),
        values.communitySearch && (React.createElement(Field, { id: "communityWebsite", name: "communityWebsite", label: intl.formatMessage(messages.identifiedPropertySite), placeholder: intl.formatMessage(messages.websitePlaceholder), component: PeekInput })),
        React.createElement(ToggleLink, { prefixText: intl.formatMessage(messages.cantFind), linkText: intl.formatMessage(messages.manuallyEnterDetails), onClick: onManualEntry })))));
};
export default SearchSelectForm;
